import { useTranslation } from "react-i18next";
import { RevealOnView } from "../reveal-on-view";

export function AboutSection() {
	const { t } = useTranslation("marketing");

	const facts = [
		t("about_fact_platforms"),
		t("about_fact_price"),
		t("about_fact_languages"),
		t("about_fact_access"),
		t("about_fact_content"),
	];

	return (
		<section id="about" className="scroll-mt-28 py-16">
			<RevealOnView from="up">
				<div className="rounded-[2rem] border border-white/10 bg-white/6 p-8 shadow-[0_24px_70px_-48px_rgba(0,0,0,0.72)] backdrop-blur sm:p-10">
					<p className="text-sm font-semibold uppercase tracking-[0.24em] text-app-accent-secondary">{t("about_eyebrow")}</p>
					<h2 className="mt-4 text-3xl font-semibold tracking-[-0.05em] text-white sm:text-4xl">{t("about_title")}</h2>
					<p className="mt-5 max-w-3xl text-lg leading-8 text-white/70">{t("about_body")}</p>
					<ul className="mt-8 grid gap-3 sm:grid-cols-2">
						{facts.map((fact) => (
							<li
								key={fact}
								className="flex items-start gap-3 rounded-2xl border border-white/8 bg-white/4 px-4 py-3 text-sm leading-6 text-white/80"
							>
								<span className="mt-1 size-1.5 shrink-0 rounded-full bg-app-accent" />
								<span>{fact}</span>
							</li>
						))}
					</ul>
				</div>
			</RevealOnView>
		</section>
	);
}
